module.exports = __webpack_public_path__ + "media/images/landing_page/2023/album_mobile_lv-395c3e37b8cf02d21441139a5e27e96d.png";